<!--
 * @Author: Code-HHX
 * @Date: 2022-04-12 15:10:41
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-05-11 14:30:01
 * @Description: 首页/登录页面
-->
<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
    </div>
    <div class="login-option w-full h-full">
      <div @click="onConsumerClick" class="radius-border horizontal items-center justify-center w-full"
          style="padding:12px;border-color: #BEBEBE">
        <van-image :src="require('@/assets/icons/v2/ic_login_consumer.svg')" width="24px" height="24px"/>
        <span class="ml-3">Consumer Account</span>
      </div>
      <div class="radius-border horizontal items-center justify-center mt-3 w-full"
          style="padding:12px;border-color: #BEBEBE;">
        <van-image :src="require('@/assets/icons/v2/ic_login_business.svg')" width="24px" height="24px"/>
        <span class="ml-3" @click="onBusinessClick">Business Account</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import log from "@/util/log";
import { TOKEN } from "@/config/http-json";
import VerifyAge from "@/components/VerifyAge.vue";
import user from "@/api/user";

export default {
  name: "Login",
  components: { VerifyAge },
  data() {
    return {};
  },
  computed: {

    ...mapState("theme", ["themeMainColor"]),
    ...mapState("user", ["userInfo"]),
    ...mapState(["brandImage"])
  },
  methods: {
    async onConsumerClick() {
      try {
        const resp = await user.identityConfirm({}, true);
        if (resp.code !== 200) {
          this.$toast({
            message: resp.message
          });
          return;
        }
        await this.$store.dispatch("user/updateUser", { identityConfirmStatus: 1 });

        this.$router.push({
          name: "PrivacyPolicy"
        }).catch(()=> {});
      } catch (e) {
        console.log(e)
        this.$toast({
          message: e
        });
      }

      // this.$router.push('/Enterprise')
    },
    onClickHeaderReturn() {
      this.$store.dispatch("user/logout");
    },

    onBusinessClick() {
      this.$store.dispatch("user/logout", { identityConfirmStatus: 1 });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background: white;
}

.login-option {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
</style>
